<script setup lang="ts">
// Features hub: every feature page, plus direct links to the public skins
// gallery and leaderboard (both moved out of the header into Features).

const title = 'Features: everything your mychar.gg page can do'
const description = 'A live drag-and-drop editor, integrations, music and clips, analytics, skins, custom domains, and more. See everything you can build with mychar.gg.'

useSeoMeta({
  title,
  titleTemplate: (t?: string | null) => (t && /mychar\.gg/i.test(t) ? t : `${t} | mychar.gg`),
  ogTitle: title,
  description,
  ogDescription: description
})

defineOgImageComponent('Saas', {
  title: 'Features',
  description: 'Everything you can build with mychar.gg.'
})

const siteUrl = useRuntimeConfig().public.siteUrl

useSchemaOrg([
  defineWebPage({ '@type': 'CollectionPage' }),
  defineBreadcrumb({
    itemListElement: [
      { name: 'Home', item: siteUrl },
      { name: 'Features', item: `${siteUrl}/features` }
    ]
  })
])
</script>

<template>
  <div>
    <UPageHero
      headline="Features"
      title="Everything your page can do"
      description="One page for your whole personal brand, designed in a live drag-and-drop editor. Here is everything you can put on it and do with it."
      :links="[
        { label: 'Create your page', to: '/signup', color: 'primary', trailingIcon: 'i-lucide-arrow-right' },
        { label: 'See pricing', to: '/pricing', color: 'neutral', variant: 'outline' }
      ]"
    />

    <UContainer class="pb-16">
      <UPageGrid>
        <UPageCard
          v-for="feature in FEATURE_LINKS"
          :key="feature.slug"
          :to="featurePath(feature.slug)"
          :title="feature.label"
          :description="feature.description"
          :icon="feature.icon"
          :highlight="feature.slug === 'editor'"
          variant="subtle"
        />
      </UPageGrid>

      <div class="mx-auto mt-16 grid max-w-5xl gap-4 sm:grid-cols-2">
        <UPageCard
          to="/skins"
          title="Browse community skins"
          description="Preview complete page themes made by other users."
          icon="i-lucide-palette"
          variant="subtle"
        />
        <UPageCard
          to="/leaderboard"
          title="See the leaderboard"
          description="The most viewed pages on mychar.gg this week and of all time."
          icon="i-lucide-trophy"
          variant="subtle"
        />
      </div>
    </UContainer>

    <CtaPanel />
  </div>
</template>
